import { axiosInstance } from "../../../axios/axiosInstance";

const API_CATEGORIES_URL = "categories/";
const API_CATEGORIES_MODULE_SELECT_LIST_URL =
  API_CATEGORIES_URL + "get-all-categories";

export const getCategoriesSelectList = (selectedLanguage) => {
  return axiosInstance.get(`${API_CATEGORIES_MODULE_SELECT_LIST_URL}?locale=${selectedLanguage?.value || 'en'}`);
};

// Super Admin

const API_CATEGORIES_ADMIN_URL = "admin/category";
const API_CATEGORY_MODULE_LIST_URL = API_CATEGORIES_ADMIN_URL + "/list";
const API_CREATE_CATEGORY_MODULE_URL = API_CATEGORIES_ADMIN_URL + "/create";
const API_GET_CATEGORY_MODULE_BY_ID_URL = API_CATEGORIES_ADMIN_URL + "/view";
const API_UPDATE_CATEGORY_MODULE_URL = API_CATEGORIES_ADMIN_URL + "/update";
const API_DELETE_CATEGORY_MODULE_URL =
  API_CATEGORIES_ADMIN_URL + "/update-status";

export const getCategories = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_CATEGORY_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${
      dataToBeSent?.limit || ""
    }&search=${dataToBeSent?.search || ""}`
  );
};

export const createCategory = (dataToBeSent) => {
  return axiosInstance.post(API_CREATE_CATEGORY_MODULE_URL, dataToBeSent);
};

export const getCategoryById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_CATEGORY_MODULE_BY_ID_URL + "/" + dataToBeSent?.selectedcategoryId
  );
};

export const updateCategory = (dataToBeSent) => {
  return axiosInstance.post(
    API_UPDATE_CATEGORY_MODULE_URL + "/" + dataToBeSent?._id,
    dataToBeSent
  );
};

export const deleteCategoryById = (dataToBeSent) => {
  return axiosInstance.patch(
    API_DELETE_CATEGORY_MODULE_URL + "/" + dataToBeSent?.selectedcategoryId,
    {
      is_active: dataToBeSent?.is_active,
    }
  );
};
